import { useCallback } from "react"

import { DocumentForm } from "@l2r-front/l2r-app-doc"
import { useTranslation } from "@l2r-front/l2r-i18n"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { useVerticalSignPoleUpdateDocument } from "../../hooks/mutations/useVerticalSignPoleUpdate"

export const VerticalSignPoleAddDocumentFormPost = (props) => {
    const {
        poleId,
        onClose,
        onSubmitting,
        onChange,
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)

    const mutation = useVerticalSignPoleUpdateDocument(poleId, {}, {
        errorSnackbarMessage: t(I18N_NAMESPACE, "containers.verticalSignPoleDocumentEditForm.snackbar.error"),
        successSnackbarMessage: t(I18N_NAMESPACE, "containers.verticalSignPoleDocumentEditForm.snackbar.success"),
        onSuccess: () => onClose(false),
        onError: (error) => {
            onSubmitting(false)
            console.error("Error updating vertical sign pole document:", error)
        },
    })

    const onSubmit = useCallback((formValues) => {
        const values = {
            document: formValues,
            vertical_sign_pole: poleId,
        }
        mutation.mutate(values)
        onSubmitting(true)
    }, [mutation, poleId, onSubmitting])

    return <DocumentForm
        isSubmitting={mutation.isPending}
        onSubmit={onSubmit}
        onCancel={() => onClose()}
        onChange={onChange}
    />
}